import request from "@/utils/request.js";

// 所有的list列表传值不一样
// sourceType (string, optional): 任务类型4-离线文件解析任务,3-在线录像解析任务,2-实时图片解析任务,1-实时视频流解析任务 ,
export const taskslist = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/tasks_list",
    data: data || {},
    method: "post"
  });
};
// 离线文件全部
export const fileslist = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/files_list",
    data: data || {},
    method: "post"
  });
};
// 离线文件shanc
export const filesbatchdelete = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/files/batch-delete",
    data: data || {},
    method: "post"
  });
};

// 离线文件左侧列表
export const getlistbycondition = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/file-group/get-list-by-condition",
    data: data || {},
    method: "post"
  });
};

// 离线文件除了全部
export const listwithgroup = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/files/list-with-group",
    data: data || {},
    method: "post"
  });
};
// 离线文件添加
export const filegroup = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/file-group",
    params: data || {},
    method: "get"
  });
};
// 离线文件编辑
export const filegroupPut = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/file-group",
    data: data || {},
    method: "put"
  });
};
// 离线文件删除
export const filegroupdelete = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/file-group/delete",
    params: data || {},
    method: "get"
  });
};

// 批量锁定
export const lockstatus = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/tasks/lock-status",
    data: data || {},
    method: "post"
  });
};
// 删除
export const batchdelete = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/tasks/batch-delete",
    data: data || {},
    method: "post"
  });
};
// 删除
export const analysisBatchdelete = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/tasks/analysis-batch-delete",
    data: data || {},
    method: "post"
  });
};
// 启动停止任务
export const tasksstatus = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/tasks/status",
    data: data || {},
    method: "post"
  });
};
// 添加
export const tasks = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/tasks",
    data: data || {},
    method: "post"
  });
};
// 获取算力值
export const aixresources = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/aix/resources",
    params: data || {}
  });
};

// 离线视频详情
export const tasksid = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/tasks/id",
    params: data || {}
  });
};
// 获取离线文件解析结果列表POST /zghz/analysis_configuration/files/file-analysis-results
export const analysisresults = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/files/file-analysis-results",
    data: data || {},
    method: "post"
  });
};
// 2.04-获取任务解析实况
export const analysisdetail = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/tasks/analysis-detail",
    data: data || {},
    method: "post"
  });
};

export const movefilesnewgroup = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/file-group/move-files-new-group",
    data: data || {},
    method: "post"
  });
};
//华智登录信息。切片上传视频用
export const authorization = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/authorization",
    params: data || {},
    method: "get"
  });
};